{
  "labels": {
    "paste": "لصق",
    "pasteAsPlaintext": "اللصق كنص عادي",
    "pasteCharts": "لصق الرسوم البيانية",
    "selectAll": "تحديد الكل",
    "multiSelect": "إضافة عنصر للتحديد",
    "moveCanvas": "نقل لوح الرسم",
    "cut": "قص",
    "copy": "نسخ",
    "copyAsPng": "نسخ إلى الحافظة بصيغة PNG",
    "copyAsSvg": "نسخ إلى الحافظة بصيغة SVG",
    "copyText": "نسخ إلى الحافظة كنص",
    "copySource": "نسخ المصدر إلى الحافظة",
    "convertToCode": "تحويل إلى كود",
    "bringForward": "جلب للأمام",
    "sendToBack": "أرسل للخلف",
    "bringToFront": "أحضر للأمام",
    "sendBackward": "أرسل للخلف",
    "delete": "حذف",
    "copyStyles": "نسخ الأنماط",
    "pasteStyles": "لصق الأنماط",
    "stroke": "الخط",
    "changeStroke": "تغيير لون القلم",
    "background": "الخلفية",
    "changeBackground": "تغيير لون الخلفية",
    "fill": "التعبئة",
    "strokeWidth": "سُمك الخط",
    "strokeStyle": "نمط الخط",
    "strokeStyle_solid": "متصل",
    "strokeStyle_dashed": "متقطع",
    "strokeStyle_dotted": "منقط",
    "sloppiness": "الإمالة",
    "opacity": "الشفافية",
    "textAlign": "محاذاة النص",
    "edges": "الحواف",
    "sharp": "حادة",
    "round": "دائرية",
    "arrowheads": "رؤوس الأسهم",
    "arrowhead_none": "لا شيء",
    "arrowhead_arrow": "سهم",
    "arrowhead_bar": "شريط",
    "arrowhead_circle": "دائرة",
    "arrowhead_circle_outline": "دائرة (مخططة)",
    "arrowhead_triangle": "مثلث",
    "arrowhead_triangle_outline": "مثلث (مخطط)",
    "arrowhead_diamond": "ألماسة",
    "arrowhead_diamond_outline": "ألماسة (مخططة)",
    "arrowhead_crowfoot_many": "Crow's foot (many)",
    "arrowhead_crowfoot_one": "Crow's foot (one)",
    "arrowhead_crowfoot_one_or_many": "Crow's foot (one or many)",
    "more_options": "خيارات إضافية",
    "arrowtypes": "نوع السهم",
    "arrowtype_sharp": "سهم حاد",
    "arrowtype_round": "سهم منحني",
    "arrowtype_elbowed": "سهم زاوي",
    "fontSize": "حجم الخط",
    "fontFamily": "نوع الخط",
    "addWatermark": "إضافة \"مصنوعة بواسطة Excalidraw\"",
    "handDrawn": "رسم باليد",
    "normal": "عادي",
    "code": "رمز",
    "small": "صغير",
    "medium": "متوسط",
    "large": "كبير",
    "veryLarge": "كبير جدًا",
    "solid": "كامل",
    "hachure": "خطوط",
    "zigzag": "متعرج",
    "crossHatch": "خطوط متقطعة",
    "thin": "نحيف",
    "bold": "داكن",
    "left": "الـيسار",
    "center": "وسط",
    "right": "يمين",
    "extraBold": "عريض",
    "architect": "معماري",
    "artist": "رسام",
    "cartoonist": "كرتوني",
    "fileTitle": "اسم الملف",
    "colorPicker": "منتقي اللون",
    "canvasColors": "تستخدم على القماش",
    "canvasBackground": "خلفية اللوحة",
    "drawingCanvas": "لوحة الرسم",
    "clearCanvas": "مسح اللوحة",
    "layers": "الطبقات",
    "actions": "الإجراءات",
    "language": "اللغة",
    "liveCollaboration": "التعاون المباشر...",
    "duplicateSelection": "تكرار",
    "untitled": "غير معنون",
    "name": "الاسم",
    "yourName": "اسمك",
    "madeWithExcalidraw": "مصنوعة بواسطة Excalidraw",
    "group": "تحديد مجموعة",
    "ungroup": "إلغاء تحديد مجموعة",
    "collaborators": "المتعاونون",
    "toggleGrid": "تبديل الشبكة",
    "addToLibrary": "أضف إلى المكتبة",
    "removeFromLibrary": "حذف من المكتبة",
    "libraryLoadingMessage": "جارٍ تحميل المكتبة...",
    "libraries": "تصفح المكتبات",
    "loadingScene": "جارٍ تحميل المشهد…",
    "loadScene": "تحميل المشهد من ملف",
    "align": "محاذاة",
    "alignTop": "محاذاة إلى الأعلى",
    "alignBottom": "محاذاة إلى الأسفل",
    "alignLeft": "محاذاة إلى اليسار",
    "alignRight": "محاذاة إلى اليمين",
    "centerVertically": "توسيط عمودي",
    "centerHorizontally": "توسيط أفقي",
    "distributeHorizontally": "التوزيع الأفقي",
    "distributeVertically": "التوزيع عموديًا",
    "flipHorizontal": "قلب أفقي",
    "flipVertical": "قلب عمودي",
    "viewMode": "نمط العرض",
    "share": "مشاركة",
    "showStroke": "إظهار منتقي لون الخط",
    "showBackground": "إظهار منتقي لون الخلفية",
    "showFonts": "إظهار منتقي الخط",
    "toggleTheme": "تبديل الوضع الفاتح/الداكن",
    "theme": "السمة",
    "personalLib": "المكتبة الشخصية",
    "excalidrawLib": "مكتبتنا",
    "decreaseFontSize": "تصغير حجم الخط",
    "increaseFontSize": "تكبير حجم الخط",
    "unbindText": "فك ربط النص",
    "bindText": "ربط النص بالحاوية",
    "createContainerFromText": "نص مغلف في حاوية",
    "link": {
      "edit": "تعديل الرابط",
      "editEmbed": "تعديل الرابط القابل للتضمين",
      "create": "إضافة رابط",
      "label": "رابط",
      "labelEmbed": "رابط وإدراج",
      "empty": "لم يتم تعيين رابط",
      "hint": "اكتب أو الصق الرابط هنا",
      "goToElement": "الانتقال إلى العنصر المستهدف"
    },
    "lineEditor": {
      "edit": "تحرير السطر",
      "editArrow": "تحرير السهم"
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "قفل",
      "unlock": "فتح",
      "lockAll": "قفل الكل",
      "unlockAll": "فتح الكل"
    },
    "statusPublished": "نُشر",
    "sidebarLock": "إبقاء الشريط الجانبي مفتوح",
    "selectAllElementsInFrame": "تحديد جميع العناصر في الإطار",
    "removeAllElementsFromFrame": "إزالة جميع العناصر من الإطار",
    "eyeDropper": "اختيار اللون من القماش",
    "textToDiagram": "نص إلى رسم بياني",
    "prompt": "تعليمات",
    "followUs": "تابعنا",
    "discordChat": "دردشة ديسكورد",
    "zoomToFitViewport": "التكبير لتناسب العرض",
    "zoomToFitSelection": "تكبير للعنصر المحدد",
    "zoomToFit": "تكبير لتلائم جميع العناصر",
    "installPWA": "تثبيت Excalidraw محليًا (PWA)",
    "autoResize": "تمكين تغيير حجم النص تلقائيًا",
    "imageCropping": "قص الصورة",
    "unCroppedDimension": "الأبعاد غير المقصوصة",
    "copyElementLink": "نسخ رابط الكائن",
    "linkToElement": "رابط إلى الكائن",
    "wrapSelectionInFrame": "تغليف التحديد في إطار",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "رابط إلى الكائن",
    "desc": "انقر على شكل على اللوحة أو الصق رابطًا.",
    "notFound": "لم يتم العثور على الكائن المرتبط على اللوحة."
  },
  "library": {
    "noItems": "لا توجد عناصر أضيفت بعد...",
    "hint_emptyLibrary": "حدد عنصر على القماش لإضافته هنا، أو تثبيت مكتبة من المستودع العام أدناه.",
    "hint_emptyPrivateLibrary": "حدد عنصر على القماش لإضافته هنا.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "البحث على اللوحة",
    "noMatch": "لم يتم العثور على تطابقات...",
    "singleResult": "نتيجة",
    "multipleResults": "نتائج",
    "placeholder": "ابحث عن نص على اللوحة...",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "إعادة تعيين اللوحة",
    "exportJSON": "صدر الملف",
    "exportImage": "تصدير الصورة...",
    "export": "حفظ إلى...",
    "copyToClipboard": "نسخ إلى الحافظة",
    "copyLink": "نسخ الرابط",
    "save": "احفظ للملف الحالي",
    "saveAs": "حفظ كـ",
    "load": "فتح",
    "getShareableLink": "احصل على رابط المشاركة",
    "close": "إغلاق",
    "selectLanguage": "اختر اللغة",
    "scrollBackToContent": "الرجوع إلى المحتوى",
    "zoomIn": "تكبير",
    "zoomOut": "تصغير",
    "resetZoom": "إعادة تعيين التكبير",
    "menu": "القائمة",
    "done": "تم",
    "edit": "تعديل",
    "undo": "تراجع",
    "redo": "إعادة تنفيذ",
    "resetLibrary": "إعادة ضبط المكتبة",
    "createNewRoom": "إنشاء غرفة جديدة",
    "fullScreen": "شاشة كاملة",
    "darkMode": "الوضع المظلم",
    "lightMode": "الوضع المضيء",
    "systemMode": "وضع النظام",
    "zenMode": "وضع التأمل",
    "objectsSnapMode": "التقاط إلى العناصر",
    "exitZenMode": "إلغاء وضع التأمل",
    "cancel": "إلغاء",
    "saveLibNames": "",
    "clear": "مسح",
    "remove": "إزالة",
    "embed": "تبديل الإدراج",
    "publishLibrary": "",
    "submit": "إرسال",
    "confirm": "تأكيد",
    "embeddableInteractionButton": "اضغط للتفاعل"
  },
  "alerts": {
    "clearReset": "هذا سيُزيل كامل اللوحة. هل أنت متأكد؟",
    "couldNotCreateShareableLink": "تعذر إنشاء رابط المشاركة.",
    "couldNotCreateShareableLinkTooBig": "تعذر إنشاء رابط قابل للمشاركة: المشهد كبير جدًا",
    "couldNotLoadInvalidFile": "تعذر التحميل، الملف غير صالح",
    "importBackendFailed": "فشل الاستيراد من الخادم.",
    "cannotExportEmptyCanvas": "لا يمكن تصدير لوحة فارغة.",
    "couldNotCopyToClipboard": "تعذر النسخ إلى الحافظة.",
    "decryptFailed": "تعذر فك تشفير البيانات.",
    "uploadedSecurly": "تم تأمين التحميل بتشفير النهاية إلى النهاية، مما يعني أن خادم Excalidraw والأطراف الثالثة لا يمكنها قراءة المحتوى.",
    "loadSceneOverridePrompt": "تحميل الرسم الخارجي سيحل محل المحتوى الموجود لديك. هل ترغب في المتابعة؟",
    "collabStopOverridePrompt": "إيقاف الجلسة سيؤدي إلى الكتابة فوق رسومك السابقة المخزنة داخليًا. هل أنت متأكد؟\n\n(إذا كنت ترغب في الاحتفاظ برسمك المخزن داخليًا، أغلق علامة تبويب المتصفح بدلاً من ذلك.)",
    "errorAddingToLibrary": "تعذر إضافة العنصر إلى المكتبة",
    "errorRemovingFromLibrary": "تعذر إزالة العنصر من المكتبة",
    "confirmAddLibrary": "هذا سيضيف {{numShapes}} شكل إلى مكتبتك. هل أنت متأكد؟",
    "imageDoesNotContainScene": "يبدو أن هذه الصورة لا تحتوي على أي بيانات مشهد. هل قمت بتمكين تضمين المشهد أثناء التصدير؟",
    "cannotRestoreFromImage": "تعذر استعادة المشهد من ملف الصورة",
    "invalidSceneUrl": "تعذر استيراد المشهد من عنوان URL المتوفر. إما أنها مشوهة، أو لا تحتوي على بيانات Excalidraw JSON صالحة.",
    "resetLibrary": "هذا سيؤدي إلى مسح مكتبتك. هل أنت متأكد؟",
    "removeItemsFromsLibrary": "حذف {{count}} عنصر (عناصر) من المكتبة؟",
    "invalidEncryptionKey": "مفتاح التشفير يجب أن يكون من 22 حرفًا. التعاون المباشر معطل.",
    "collabOfflineWarning": "لا يوجد اتصال بالإنترنت.\nلن يتم حفظ التغييرات التي قمت بها!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "نوع الملف غير مدعوم.",
    "imageInsertError": "تعذر إدراج الصورة. حاول مرة أخرى لاحقًا...",
    "fileTooBig": "الملف كبير جدًا. الحد الأقصى المسموح به للحجم هو {{maxSize}}.",
    "svgImageInsertError": "تعذر إدراج صورة SVG. يبدو أن ترميز SVG غير صحيح.",
    "failedToFetchImage": "فشل تحميل الصورة.",
    "cannotResolveCollabServer": "تعذر الاتصال بخادم التعاون. الرجاء إعادة تحميل الصفحة والمحاولة مرة أخرى.",
    "importLibraryError": "تعذر تحميل المكتبة",
    "saveLibraryError": "تعذر حفظ المكتبة. الرجاء حفظ المكتبة الخاصة بك في ملف محلي للتأكد من أنك لا تفقد التغييرات.",
    "collabSaveFailed": "تعذر الحفظ في قاعدة البيانات. إذا استمرت المشاكل، يُفضل حفظ ملفك محليًا كي لا تفقد عملك.",
    "collabSaveFailed_sizeExceeded": "تعذر الحفظ في قاعدة البيانات، يبدو أن القماش كبير للغاية، يُفضل حفظ الملف محليًا كي لا تفقد عملك.",
    "imageToolNotSupported": "تم تعطيل الصور.",
    "brave_measure_text_error": {
      "line1": "يبدو أنك تستخدم متصفح Brave مع إعداد <bold>حظر صارم لتتبع البصمة</bold>.",
      "line2": "قد يؤدي هذا إلى كسر <bold>عناصر النص</bold> في الرسومات الخاصة بك.",
      "line3": "من المستحسن إلغاء تفعيل هذا الإعداد. يمكنك اتباع <link>هذه الخطوات</link> لفعل ذلك.",
      "line4": "إذا لم يصلح تعطيل هذا الإعداد طريقة عرض النصوص، الرجاء كتابة <issueLink>بلاغ</issueLink> على حسابنا في GitHub، أو راسلنا على <discordLink>Discord</discordLink>"
    },
    "libraryElementTypeError": {
      "embeddable": "لا يمكن إضافة العناصر القابلة للتضمين في المكتبة.",
      "iframe": "لا يمكن إضافة عناصر IFrame إلى المكتبة.",
      "image": "سيتم دعم إضافة صور إلى المكتبة قريبًا!"
    },
    "asyncPasteFailedOnRead": "تعذر اللصق (تعذر القراءة من حافظة النظام).",
    "asyncPasteFailedOnParse": "تعذر اللصق.",
    "copyToSystemClipboardFailed": "تعذر النسخ إلى الحافظة."
  },
  "toolBar": {
    "selection": "تحديد",
    "lasso": "",
    "image": "إدراج صورة",
    "rectangle": "مستطيل",
    "diamond": "مضلع",
    "ellipse": "دائرة",
    "arrow": "سهم",
    "line": "خط",
    "freedraw": "رسم",
    "text": "نص",
    "library": "مكتبة",
    "lock": "الحفاظ على أداة التحديد نشطة بعد الرسم",
    "penMode": "وضع القلم - منع اللمس",
    "link": "إضافة/تحديث الرابط للشكل المحدد",
    "eraser": "ممحاة",
    "frame": "أداة الإطار",
    "magicframe": "Wireframe إلى كود",
    "embeddable": "تضمين ويب",
    "laser": "مؤشر ليزر",
    "hand": "يد (أداة الإزاحة)",
    "extraTools": "المزيد من الأدوات",
    "mermaidToExcalidraw": "من Mermaid إلى Excalidraw",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "مستطيل",
    "diamond": "مضلع",
    "ellipse": "دائرة",
    "arrow": "سهم",
    "line": "خط",
    "freedraw": "رسم حر",
    "text": "نص",
    "image": "صورة",
    "group": "مجموعة",
    "frame": "إطار",
    "magicframe": "Wireframe إلى كود",
    "embeddable": "تضمين ويب",
    "selection": "تحديد",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "إجراءات اللوحة",
    "selectedShapeActions": "إجراءات الشكل المحدد",
    "shapes": "الأشكال"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "انقر لبدء نقاط متعددة، اسحب لخط واحد",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "انقر واسحب، أفرج عند الانتهاء",
    "text": "نصيحة: يمكنك أيضًا إضافة نص بالنقر المزدوج في أي مكان بأداة الاختيار",
    "embeddable": "اضغط مع السحب لإنشاء موقع ويب مضمّن",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "نشر مكتبتك",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "يمكن على الأرجح تمكين هذه الميزة عن طريق تعيين علم \"dom.events.asyncClipboard.clipboardItem\" إلى \"true\". لتغيير أعلام المتصفح في Firefox، قم بزيارة صفحة \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "تعذر عرض المعاينة",
    "canvasTooBig": "قد تكون اللوحة كبيرة جدًا.",
    "canvasTooBigTip": "نصيحة: حاول تحريك العناصر البعيدة بشكل أقرب قليلاً."
  },
  "errorSplash": {
    "headingMain": "حدث خطأ. حاول <button>تحديث الصفحة</button>.",
    "clearCanvasMessage": "إذا لم تعمل إعادة التحميل، حاول مرة أخرى ",
    "clearCanvasCaveat": "هذا سيؤدي إلى فقدان العمل",
    "trackedToSentry": "تم تتبع الخطأ في المعرف {{eventId}} على نظامنا.",
    "openIssueMessage": "حرصنا على عدم إضافة معلومات المشهد في بلاغ الخطأ. في حال كون مشهدك لا يحمل أي معلومات خاصة، نرجو المتابعة على <button>نظام تتبع الأخطاء</button>. نرجو إضافة المعلومات أدناه بنسخها ولصقها في محتوى البلاغ على GitHub.",
    "sceneContent": "محتوى المشهد:"
  },
  "shareDialog": {
    "or": "أو"
  },
  "roomDialog": {
    "desc_intro": "ادعُ الأشخاص للتعاون في الرسم الخاص بك.",
    "desc_privacy": "لا تقلق، الجلسة مشفرة من النهاية إلى النهاية وخصوصية تمامًا. حتى خادمنا لا يستطيع رؤية ما ترسمه.",
    "button_startSession": "بدء الجلسة",
    "button_stopSession": "إيقاف الجلسة",
    "desc_inProgressIntro": "تجري الآن جلسة تعاون مباشرة.",
    "desc_shareLink": "شارك هذا الرابط مع أي شخص تريده أن يشاركك الجلسة:",
    "desc_exitSession": "إيقاف الجلسة سيؤدي إلى قطع الاتصال الخاص بك من الغرفة، ولكن ستتمكن من مواصلة العمل مع المشهد محليًا. لاحظ أن هذا لن يؤثر على الأشخاص الآخرين، وسيظلون قادرين على التعاون في إصدارهم.",
    "shareTitle": "الانضمام إلى جلسة تعاون مباشرة على Excalidraw"
  },
  "errorDialog": {
    "title": "خطأ"
  },
  "exportDialog": {
    "disk_title": "حفظ الملف على الجهاز",
    "disk_details": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقًا.",
    "disk_button": "حفظ إلى ملف",
    "link_title": "رابط قابل للمشاركة",
    "link_details": "تصدير الملف للمشاهدة فقط.",
    "link_button": "تصدير كرابط",
    "excalidrawplus_description": "حفظ المشهد إلى مساحة العمل +Excalidraw الخاصة بك.",
    "excalidrawplus_button": "تصدير",
    "excalidrawplus_exportError": "تعذر التص несп في الوقت الحالي إلى +Excalidraw..."
  },
  "helpDialog": {
    "blog": "اقرأ مدونتنا",
    "click": "انقر",
    "deepSelect": "تحديد عميق",
    "deepBoxSelect": "تحديد عميق داخل المربع، ومنع السحب",
    "createFlowchart": "إنشاء مخطط تدفق من عنصر عام",
    "navigateFlowchart": "التنقل في مخطط تدفق",
    "curvedArrow": "سهم منحني",
    "curvedLine": "خط منحني",
    "documentation": "دليل الاستخدام",
    "doubleClick": "انقر مرتين",
    "drag": "اسحب",
    "editor": "المحرر",
    "editLineArrowPoints": "تحرير نقاط السطر/السهم",
    "editText": "تعديل النص / إضافة تسمية",
    "github": "عثرت على مشكلة؟ أرسل",
    "howto": "اتبع التعليمات",
    "or": "أو",
    "preventBinding": "منع ارتباط السهم",
    "tools": "الأدوات",
    "shortcuts": "اختصارات لوحة المفاتيح",
    "textFinish": "إنهاء التعديل (محرر النص)",
    "textNewLine": "إضافة سطر جديد (محرر النص)",
    "title": "المساعدة",
    "view": "عرض",
    "zoomToFit": "تكبير للملائمة",
    "zoomToSelection": "تكبير للعنصر المحدد",
    "toggleElementLock": "قفل/فتح المحدد",
    "movePageUpDown": "نقل الصفحة أعلى/أسفل",
    "movePageLeftRight": "نقل الصفحة يسار/يمين",
    "cropStart": "بدء قص الصورة",
    "cropFinish": "إنهاء قص الصورة"
  },
  "clearCanvasDialog": {
    "title": "مسح اللوحة"
  },
  "publishDialog": {
    "title": "نشر المكتبة",
    "itemName": "اسم العنصر",
    "authorName": "اسم المؤلف",
    "githubUsername": "اسم المستخدم في GitHub",
    "twitterUsername": "اسم المستخدم في تويتر",
    "libraryName": "اسم المكتبة",
    "libraryDesc": "وصف المكتبة",
    "website": "الموقع",
    "placeholder": {
      "authorName": "اسمك أو اسم المستخدم",
      "libraryName": "اسم مكتبتك",
      "libraryDesc": "وصف مكتبتك لمساعدة الناس على فهم استخدامها",
      "githubHandle": "معرف GitHub (اختياري)، حتى تتمكن من تحرير المكتبة عند إرسالها للمراجعة",
      "twitterHandle": "اسم مستخدم تويتر (اختياري)، حتى نعرف من الذي سيتم الإشارة إليه عند الترويج عبر تويتر",
      "website": "رابط إلى موقعك الشخصي أو مكان آخر (اختياري)"
    },
    "errors": {
      "required": "مطلوب",
      "website": "أدخل عنوان URL صالح"
    },
    "noteDescription": "تقديم مكتبتك لتضمينها في مستودع المكتبة العامة <link></link> ليستخدمها الآخرون في رسوماتهم.",
    "noteGuidelines": "تحتاج المكتبة إلى الموافقة أولاً. يرجى قراءة <link>المعايير</link> قبل تقديمها. ستحتاج إلى حساب GitHub للتواصل وإجراء التغييرات عند الطلب، ولكنه ليس مطلوبًا بشكل صارم.",
    "noteLicense": "تقديمك يعني موافقتك على نشر المكتبة المقدمة تحت <link>ترخيص MIT</link>، مما يعني أن لأي شخص الحق في استخدامها دون قيود.",
    "noteItems": "يجب أن يكون لكل عنصر مكتبة اسم خاص به ليكون قابلًا للتصفية. سيتم تضمين عناصر المكتبة التالية:",
    "atleastOneLibItem": "يرجى تحديد عنصر مكتبة واحد على الأقل للبدء",
    "republishWarning": "ملاحظة: بعض العناصر المحددة معينة على أنها نُشرت أو قُدمت من قبل. يجب عليك فقط إعادة إرسال العناصر عند تحديث مكتبة موجودة أو إرسالها."
  },
  "publishSuccessDialog": {
    "title": "تم إرسال المكتبة",
    "content": "شكرًا لك {{authorName}}. لقد تم إرسال مكتبتك للمراجعة. يمكنك تتبع الحالة"
  },
  "confirmDialog": {
    "resetLibrary": "إعادة ضبط المكتبة",
    "removeItemsFromLib": "إزالة العناصر المحددة من المكتبة"
  },
  "imageExportDialog": {
    "header": "تصدير الصورة",
    "label": {
      "withBackground": "مع الخلفية",
      "onlySelected": "المحدد فقط",
      "darkMode": "الوضع الداكن",
      "embedScene": "تضمين المشهد",
      "scale": "المقياس",
      "padding": "الهوامش"
    },
    "tooltip": {
      "embedScene": "سيتم حفظ بيانات المشهد في ملف PNG/SVG المصدر بحيث يمكن استعادة المشهد منه.\nسيزيد هذا من حجم الملف المصدر."
    },
    "title": {
      "exportToPng": "تصدير بصيغة PNG",
      "exportToSvg": "تصدير بصيغة SVG",
      "copyPngToClipboard": "نسخ الـ PNG إلى الحافظة"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "نسخ إلى الحافظة"
    }
  },
  "encrypted": {
    "tooltip": "رسوماتك مشفرة من النهاية إلى النهاية، لذا لا يمكن لخوادم Excalidraw رؤيتها أبدًا.",
    "link": "مشاركة المدونة حول التشفير من النهاية إلى النهاية في Excalidraw"
  },
  "stats": {
    "angle": "الزاوية",
    "shapes": "الأشكال",
    "height": "الارتفاع",
    "scene": "المشهد",
    "selected": "المحدد",
    "storage": "التخزين",
    "fullTitle": "خصائص اللوحة والأشكال",
    "title": "الخصائص",
    "generalStats": "عام",
    "elementProperties": "خصائص الشكل",
    "total": "المجموع",
    "version": "الإصدار",
    "versionCopy": "انقر للنسخ",
    "versionNotAvailable": "الإصدار غير متوفر",
    "width": "العرض"
  },
  "toast": {
    "addedToLibrary": "تمت الإضافة إلى المكتبة!",
    "copyStyles": "تم نسخ الأنماط.",
    "copyToClipboard": "تم النسخ إلى الحافظة.",
    "copyToClipboardAsPng": "تم نسخ {{exportSelection}} إلى الحافظة بصيغة PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "تم نسخ {{exportSelection}} إلى الحافظة بصيغة SVG\n({{exportColorScheme}})",
    "fileSaved": "تم حفظ الملف.",
    "fileSavedToFilename": "تم الحفظ باسم {filename}",
    "canvas": "لوحة الرسم",
    "selection": "العنصر المحدد",
    "pasteAsSingleElement": "استخدم {{shortcut}} للصق كعنصر واحد،\nأو لصق في محرر نص موجود",
    "unableToEmbed": "تضمين هذا الرابط غير مسموح حاليًا. افتح بلاغًا على GitHub لطلب إدراج عنوان URL في القائمة البيضاء",
    "unrecognizedLinkFormat": "الرابط الذي أدرجته لا يتطابق مع التنسيق المتوقع. الرجاء محاولة لصق النص 'المضمن' المُزوَد من موقع المصدر",
    "elementLinkCopied": "تم نسخ الرابط إلى الحافظة"
  },
  "colors": {
    "transparent": "شفاف",
    "black": "أسود",
    "white": "أبيض",
    "red": "أحمر",
    "pink": "وردي",
    "grape": "عنبي",
    "violet": "بنفسجي",
    "gray": "رمادي",
    "blue": "أزرق",
    "cyan": "سماوي",
    "teal": "أزرق مخضر",
    "green": "أخضر",
    "yellow": "أصفر",
    "orange": "برتقالي",
    "bronze": "برونزي"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "هل تريد الانتقال إلى Excalidraw+ بدلاً من ذلك؟",
      "menuHint": "التصدير، التفضيلات، اللغات..."
    },
    "defaults": {
      "menuHint": "التصدير، التفضيلات، وغيرها...",
      "center_heading": "الرسم البياني التصويري، ببساطة.",
      "toolbarHint": "اختر أداة وابدأ الرسم!",
      "helpHint": "الاختصارات والمساعدة"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "الألوان المخصصة الأكثر استخدامًا",
    "colors": "الألوان",
    "shades": "الدرجات",
    "hexCode": "رمز Hex",
    "noShades": "لا تتوفر درجات لهذا اللون"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "تصدير كصورة",
        "button": "تصدير كصورة",
        "description": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقًا."
      },
      "saveToDisk": {
        "title": "حفظ الملف على الجهاز",
        "button": "حفظ الملف على الجهاز",
        "description": "تصدير بيانات المشهد إلى ملف يمكنك الاستيراد منه لاحقًا."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "تصدير إلى Excalidraw+",
        "description": "حفظ المشهد إلى مساحة العمل +Excalidraw الخاصة بك."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "تحميل من ملف",
        "button": "تحميل من ملف",
        "description": "سيتم التحميل من الملف <bold>استبدال المحتوى الموجود</bold>.<br></br>يمكنك النسخ الاحتياطي لرسمك أولاً باستخدام أحد الخيارات أدناه."
      },
      "shareableLink": {
        "title": "تحميل من رابط",
        "button": "استبدال محتواي",
        "description": "سيتسبب تحميل رسمة خارجية <bold>باستبدال محتواك الموجود حاليًا</bold>.<br></br>بإمكانك إجراء النسخ الاحتياطي لرسمتك الحالية باستخدام أحد الخيارات أدناه."
      }
    }
  },
  "mermaid": {
    "title": "Mermaid إلى Excalidraw",
    "button": "إدراج",
    "description": "حاليًا، يتم دعم <flowchartLink>مخططات التدفق</flowchartLink>، <sequenceLink>التسلسلات</sequenceLink>، و<classLink>الفئات</classLink> فقط. سيتم عرض الأنواع الأخرى كصورة في Excalidraw.",
    "syntax": "صيغة Mermaid",
    "preview": "معاينة",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": "بحث سريع"
  },
  "fontList": {
    "badge": {
      "old": "قديم"
    },
    "sceneFonts": "في هذا المشهد",
    "availableFonts": "الخطوط المتوفرة",
    "empty": "لم يتم العثور على خطوط"
  },
  "userList": {
    "empty": "لم يتم العثور على مستخدمين",
    "hint": {
      "text": "انقر على المستخدم للمتابعة",
      "followStatus": "أنت حاليًا تتابع هذا المستخدم",
      "inCall": "المستخدم في مكالمة صوتية",
      "micMuted": "ميكروفون المستخدم مكتم",
      "isSpeaking": "المستخدم يتحدث"
    }
  },
  "commandPalette": {
    "title": "لوحة الأوامر",
    "shortcuts": {
      "select": "اختر",
      "confirm": "تأكيد",
      "close": "إغلاق"
    },
    "recents": "المستخدمة مؤخرًا",
    "search": {
      "placeholder": "ابحث في القوائم، الأوامر، واكتشف الجواهر المخفية",
      "noMatch": "لا توجد أوامر مطابقة..."
    },
    "itemNotAvailable": "الأمر غير متوفر...",
    "shortcutHint": "للحصول على لوحة الأوامر، استخدم {{shortcut}}"
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
